// Xceed Infrastructure Technologies — the FRONTEND face of the client config seam. The '@client/config'
// vite alias resolves here in this fork (web/vite.config.js repoint — the
// fork's one sanctioned edit outside client-custom/).
//
// ONE SOURCE OF TRUTH: these values mirror ../config/client.config.js (the
// server face). The config suite asserts the two never drift — edit BOTH
// or the runner goes RED.

export const BRAND_NAME = 'Xceed Infrastructure Technologies';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'Xceed Infrastructure Technologies — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher (see the
// server-side config). Mirrors client.config.js; the config suite checks.
export const SITE_SWITCH_GROUP = 'site-switchers';
export const STORAGE_PREFIX = 'xceed-infrastructure-technologies';

export const PROJECT_ISSUE_TYPE = 'Project';
export const MODULE_ISSUE_TYPE = 'Module';
export const LINK_TYPE_NAME = 'Parent - Child';

export const WPO_FIELD = 'customfield_10001';

export const ACCENT_RGB = { r: 245, g: 163, b: 0 };

export const CUSTOMS_ALLOWED_HOSTS = [];

// ---- the legacy formula columns ---------------------------------------------
// main.jsx imports this file, so it is the one client module guaranteed to
// load at boot — which is where the formula columns install themselves onto
// the shared api object (see ./formula-columns.js for why that is the seam).
//
// GUARDED AND DYNAMIC on purpose. The config suite imports THIS file under
// node to check the two config faces have not drifted, and node cannot resolve
// the '@app/services/api' alias that the installer needs. Behind the window
// check it never runs there, so the suite stays green; in the browser it runs
// once, at boot, long before any grid route is reachable.
if (typeof window !== 'undefined') {
  Promise.all([import('./formula-columns.js'), import('@app/services/api')])
    .then(([mod, apiMod]) => { mod.install(apiMod.default || apiMod); })
    .catch((e) => console.error('[formula columns] not installed —', e && e.message));
}
